import { Dialog, DialogContent } from '@mui/material';
export default function BackdropTable({
    open,
    handleClose,
    table,  
}: BackdropTableProps) {

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            scroll="body"
            maxWidth="lg"
        >

            <DialogContent sx={{ p: 0 }}>
                {table}
            </DialogContent>
        </Dialog>
    );
}

interface BackdropTableProps {
    open: boolean,
    handleClose: () => void,
    table: JSX.Element
}